import React from 'react'

export default class Ehawk extends React.Component {
  componentDidMount() {
    if(!document.getElementById("talon")) {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden")
      input.setAttribute("name", "talon")
      input.setAttribute("id", "talon")
      input.setAttribute("value", '{"version": 5, "status": -1}')
      document.body.appendChild(input)
    }

    if(window.eHawkTalon) {
      window.eHawkTalon();
    }
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupWidget/Ehawk.js